import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url:    String,
    handle: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle:    this.handleValue || undefined,
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: this._onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  _onEnd({ oldIndex, newIndex }) {
    if (oldIndex === newIndex) return

    const ids = [...this.element.querySelectorAll("[data-id]")]
      .map(el => el.dataset.id)

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type":  "application/json",
        "X-CSRF-Token":  document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ step_ids: ids })
    })
  }
}
